export const FEEDBACK_URL = 'https://www.surveymonkey.com/r/pepper'

/**
 * The PEPPER DAO on Aragon (Chiliz mainnet). The community treasury now lives
 * in the MainDAO, supervised by the elected PEPPER Ministers, with dedicated
 * SubDAOs for Minister operations and treasury buybacks.
 */
export const DAO_URLS = {
	main: 'https://app.aragon.org/dao/chiliz-mainnet/0x26Ed279F6d9F1bb016f16e75704E6bBCc1F99213/dashboard',
	minister: 'https://app.aragon.org/dao/chiliz-mainnet/0x05bf7dc3832D31C81ae26a9267E26879ec68BB19/dashboard',
	buyback: 'https://app.aragon.org/dao/chiliz-mainnet/0xa59C8Ac26FA3fe89C2294D2522f3d292A8d70840/dashboard'
} as const

/** Primary DAO link used by the announcement bar and top-level CTAs. */
export const DAO_URL = DAO_URLS.main

/**
 * Toggle for the site-wide announcement bar. Kept as a single switch so the
 * banner (and its layout offsets) can be hidden between campaigns by flipping
 * this to `false`; update the copy/URL in AnnouncementBar when reusing it.
 */
export const SHOW_ANNOUNCEMENT_BAR = true
